export const isNotHidden =
  <T extends { hidden?: boolean }>() =>
  (item: T): item is T =>
    !item.hidden
